module.exports = __webpack_public_path__ + "../front/img/768_bøjlestang+1hylde.69005f48.png";